<div class="simple-modal fade" role="dialog" tabindex="-1" [class.in]="visibleAnimate" [ngStyle]="{'display': (visible?'block':'none')}"> 
  <div class="simple-modal-dialog"  [ngStyle]="{'background': data.background}">
    <div class="simple-modal-content" >
      <div class="simple-modal-header" *ngIf="data.header!='hide'">
        <ng-container *ngTemplateOutlet="header"></ng-container>
        <!-- <button class="close" data-dismiss="simple-modal" type="button" aria-label="Close" (click)="close()">×</button> -->
      </div>
      <div class="simple-modal-body uk-position-relative">
        <button *ngIf="data.btnClose!='hide'" 
                data-dismiss="simple-modal" 
                type="button" 
                aria-label="Close" 
                (click)="close()" 
                class="uk-position-small uk-position-top-right uk-modal-close-default +border-close modal-close-button"
                type="button">
          <span class="close-icon"></span>
        </button>
        <ng-container *ngTemplateOutlet="body"></ng-container>
      </div>
      <div class="simple-modal-footer">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      </div>
    </div>
  </div>
</div>